// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"minimize":true,"sourceMap":true,"alias":{"../img":"../static/img"}}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1ff3599b","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./src/views/components/RouteAllocation/RouteAllocation.scss
// module id = 1206
// module chunks = 1